import { put, race, select, take } from 'redux-saga/effects';

import {
  SettingsOptionsKiActionCreators,
  SettingsOptionsKiActionTypes,
  settingsOptionsKiLoadingSelector,
  settingsOptionsKiSearchConditionSelector,
} from '../redux/server/settingsOptionsKi';

/**
 * タイプ列の選択肢の並びに使う sisTypes の名前を返す。
 * 機種設定が未取得なら取得を待つ。取得に失敗したときは空配列になり、行の値の順で選択肢を作る。
 */
export function* sisTypeNamesForTypeMultiFilterSaga() {
  const kiOptionsLoadingState: ReturnType<
    typeof settingsOptionsKiLoadingSelector
  > = yield select(settingsOptionsKiLoadingSelector);
  if (kiOptionsLoadingState !== 'loaded') {
    if (kiOptionsLoadingState !== 'loading') {
      yield put(SettingsOptionsKiActionCreators.fetchSettingsOptionsKiAction());
    }
    yield race({
      success: take(
        SettingsOptionsKiActionTypes.FETCH_SETTINGS_OPTIONS_KI_SUCCESS
      ),
      reset: take(SettingsOptionsKiActionTypes.RENEW_SETTINGS_OPTIONS_KI),
    });
  }

  const kiSearchCondition: ReturnType<
    typeof settingsOptionsKiSearchConditionSelector
  > = yield select(settingsOptionsKiSearchConditionSelector);
  return kiSearchCondition.sisTypes.map((item) => item.name);
}
